export const isEsc = (e: any) => /escape/i.test(e.key)

export const isEnter = (e: any) => /enter/i.test(e.key)